export default __webpack_public_path__ + "static/media/loader.c3af073a.gif";